export default __webpack_public_path__ + "static/media/multi-part-child-icon.1b6faebb.png";